function getToken() {
  const search = window.location.search;
  const params = new URLSearchParams(search);
  return params.get('m');
}

export default getToken;
